/**
 * @generated SignedSource<<3db9d4bc8d19d19d9cfe37c02c44f0d6>>
 * @relayHash f760e3b2d740a1f6e9c4d2cb3cc89946
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AutomationPopupMenuContentQuery } from './AutomationPopupMenuContentQuery.graphql';

const node: PreloadableConcreteRequest<AutomationPopupMenuContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc",
    "metadata": {},
    "name": "AutomationPopupMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
